export const VALIDATION_STATES = ['success', 'warning', 'error', undefined];

export const assertValidState = state => {
  if (VALIDATION_STATES.includes(state)) return;
  throw new TypeError(`'${state}' is not a valid state`);
};

export const getInputClassForValidationState = validationState => {
  assertValidState(validationState);
  return validationState ? `input--${validationState}` : '';
};
